import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Vector3 } from 'three';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class TipsHolderModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('micropipette_tips_holder').clone();
        this.addObject(this.model);
        this.level = level;
    }
    init() { }
    initPicking() {
        this.actionController.once(ActionControllerEventName.click, this.model, () => {
            if (Viewer.controls.zController)
                return;
            this.fire('holder_clicked');
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                const distanceToTips = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(new Vector3(-26.7, -17, -8));
                if (distanceToTips < 1.3) {
                    this.fire('holder_clicked');
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                }
                setTimeout(() => pipetteUiObject.traverse(el => {
                    if (el.userData.oldRaycast)
                        el.raycast = el.userData.oldRaycast;
                }));
                this.actionController.off(ActionControllerEventName.click, this.model);
            });
        }
    }
    setTipVisibility(value) {
        this.model.getObjectByName('tip1').visible = value;
    }
}
